import { render } from "./PrescriptionProtocolDrugs.vue?vue&type=template&id=87fc384a&scoped=true"
import script from "./PrescriptionProtocolDrugs.vue?vue&type=script&lang=js"
export * from "./PrescriptionProtocolDrugs.vue?vue&type=script&lang=js"

import "./PrescriptionProtocolDrugs.vue?vue&type=style&index=0&id=87fc384a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fc384a"]])

export default __exports__